import { Typography } from '@montugroup/design-system';
import { styled, useTheme } from '@mui/material';
import eTokenExample from '../../../assets/images/eTokenExample.svg';
import { ResponsiveDialog } from '../../responsiveDialog/ResponsiveDialog';
import { StyledDialogContent, StyledDialogImage } from './TokenDialogStyles';

interface ITokenDialog {
  onClose: () => void;
  open: boolean;
}

const StyledResponsiveDialog = styled(ResponsiveDialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: theme.spacing(4),
    maxWidth: theme.spacing(107),
    [theme.breakpoints.down('sm')]: {
      borderBottomLeftRadius: theme.spacing(0),
      borderBottomRightRadius: theme.spacing(0),
    },
    '& .MuiBox-root': {
      padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
    },
    '& .MuiDialogContent-root': {
      padding: `${theme.spacing(2)} ${theme.spacing(6)} ${theme.spacing(6)}`,
    },
  },
}));

export function TokenDialog({ onClose, open }: ITokenDialog) {
  const theme = useTheme();

  return (
    <StyledResponsiveDialog open={open} onClose={onClose} title="Where to find your token" closeButton>
      <StyledDialogContent>
        <StyledDialogImage src={eTokenExample} sx={{ borderRadius: theme.spacing(4), maxWidth: theme.spacing(75) }} />
        <Typography marginTop={6} variant="body2">
          You may have received your electronic prescription via email or SMS. The script token is an 18-digit code that
          accompanies a QR code.
        </Typography>
        <Typography marginTop={6} variant="body2">
          You can also find the script token in the link to your prescription.
        </Typography>
      </StyledDialogContent>
    </StyledResponsiveDialog>
  );
}
